import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomAutocomplete,
  EstadoComponente,
} from "@/shared/components/ui";
import {
  useRemoveSolicitudesEgresos,
  useUpdateSolicitudesEgresos,
  useFetchSolicitudesEgreso,
  useFetchMotivosRechazo,
} from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import {
  AlertSeverityEnum,
  DetalleUsuarios,
  EstadosSolicitudPeodidoEnum,
  MaterialTransferido,
  MotivoRechazo,
} from "@/shared/interfaces";
import { Grid, IconButton, TextField, Tooltip } from "@mui/material";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useEffect, useState } from "react";
//import { SampleTable } from "@/shared/components/ui";
import { useUiStore } from "@/store/ui";
import { useMemo } from "react";
import { useMaterialesUtilizadosStore } from "@/store/erp";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { PermissionsEnum } from "@/auth/interfaces";
import { SolicitudesEgreso } from "@/shared/interfaces/erp/compras/solicitudes-egreso.interface";
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import { cellNotFilter, formatDateWithTimeCell, ROUTER_PATHS } from "@/shared";
import CustomCantidadRecibidaInput from "@/shared/components/ui/CustomCantidadRecibidaInput";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral";



export default function SolicitudPedidosUsuariosEnesperaPagina() {
  useCheckPermissions(PermissionsEnum.api_change_solicitudegreso)
  //*
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const setPaginationTableProducto = useCargarSeriesProductos(s => s.setPagination)
  const paginationTableProducto = useCargarSeriesProductos(s => s.pagination)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  //console.log('prodcutos', productos)
  ///
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const returnUrlPedidosusuarios = ROUTER_PATHS.inventario.solicitud_pedido_nav
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialogIsOpen2 = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);

  const deleteSolicitudesUsuariosPedido = useRemoveSolicitudesEgresos();
  const clearProductoSinSeriesItems = useMaterialesUtilizadosStore(
    (s) => s.clearProductoSinSeriesItems
  );
  const clearProductoSeriesItems = useMaterialesUtilizadosStore(
    (s) => s.clearProductoSeriesItems
  )
  //const clearSelectedItems = useMaterialesUtilizadosStore(s => s.clearSelectedItems);
  const updateSolicitudesPedidos = useUpdateSolicitudesEgresos({
    navigate,
    returnUrl: returnUrlPedidosusuarios,
  });
  const [idEdit, setIdEdit] = useState<string | null>(null);
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isVisibility1, setIsVisibility1] = useState(false)
  const [idSolicitudEgreso, setIdSolicitudEgreso] = useState(false)
  /* const [nomBodega, setNomBodega] = useState<string | null>(null)
  const [nomUbicacion, setNomUbicacion] = useState<string | null>(null); */
  ///const [isModalOpen4, setIsModalOpen4] =useState(false);
  /* console.log(nomBodega)
  console.log(nomUbicacion) */


  ///7alert
  const setAlert = useUiStore((s) => s.setAlert);

  const onSaveEdit = () => {

    try {

      if (idEdit) {

        const campoInvalido = productos.find(item => item.cantidad_aprobada! <= 0 || isNaN(item.cantidad_aprobada!))
        if (campoInvalido) {
          setAlert(true, `El producto "${campoInvalido.codigo}" tiene una cantidad aprobada inválida, debe ser mayor a cero.`, AlertSeverityEnum.error)
          return;
        }
        //return;

        let isValid = true
        // solicitudEgreso.forEach((elemento)=>{
          
        //   if(!elemento.cantidad_aprobada || elemento.cantidad_acumulada){
        //     setAlert(true, "El campo Cantidad Aprobada no puede estar vacío.", AlertSeverityEnum.error);
        //     isValid=false
        //   }
        // })
        if(!isValid){
           return
        }

        // const productoEgreso = solicitudEgreso.map((element) => ({
        //   ...element,
        //   cantidad_aprobada: element.cantidad_aprobada,
        //   ///cantidad: element.cantidad_recibida.toString(),

        // }))
      
        updateSolicitudesPedidos.mutate(
          {
            id: idEdit!,
            data: {
              estado_solicitud: EstadosSolicitudPeodidoEnum.APROBADAS,
              productos: productos,
              //observaciones: form.getValues().observaciones,
            },
          },
          {
            onSuccess: () => {
              setIsModalOpen(false);
              setConfirmDialogIsOpen(false);
              setConfirmDialogIsOpen2(false);
              form.reset({ observaciones: "" });
              refetch();
              handleAprobar();
            },
            onError: (error: any) => {
              console.error("Error en la mutación", error);
            },
          }
        ); 
      } else {
        console.error("idEdit is null");
      }
    } catch (error) {
      console.error("Error en la mutación", error);
    }
  };

  type SaveFormData = {
    motivo_rechazo: string;
    observaciones: string;
    cantidad_aprobada: number;
  };

  const form = useForm<SaveFormData>();

  const {
    control,
    formState: { errors },
  } = form;

  const handleConfirm = () => {
    if (form.getValues().motivo_rechazo === "") {
      setAlert(true, "Seleccione un motivo, para proceder con la confirmación.", AlertSeverityEnum.error)
      return;
    }
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro que deseas rechazar el pedido seleccionado?",
      title: "Confirmar rechazo",
      onConfirm: () => {
        try {
          setIsModalOpen3(true);
          if (idEdit) {
            deleteSolicitudesUsuariosPedido.mutate(
              {
                id: idEdit!,
                data: {
                  motivo_rechazo: form.getValues().motivo_rechazo,
                  estado_solicitud: EstadosSolicitudPeodidoEnum.RECHAZADO,
                },
              },
              {
                onSuccess: () => {
                  setIsModalOpen(false);
                  setConfirmDialogIsOpen(false);
                  setIsModalOpen3(false);
                  setConfirmDialogIsOpen2(false);
                  refetch();
                },
                onError: (error: any) => {
                  console.error("Error en la mutación", error);
                },
              }
            );
          } else {
            console.error("idEdit is null");
          }
        } catch (error) {
          console.error("Error en la mutación", error);
        }
        refetch();
      },
      onClose() {
        setIsModalOpen(false);
        setConfirmDialogIsOpen(false);
        refetch();
        clearProductoSeriesItems();
        clearProductoSinSeriesItems();
        setIsModalOpen3(false)
      },
    });
  };




  ///
  const handleAprobar = () => {
    setConfirmDialog({
      isOpen: true,
      title: "¡Aprobado con éxito!",
      subtitle: "La solicitud de pedido se ha aprobado correctamente, deseas realizar la trasferencia. ¿Te gustaría continuar?",
      onConfirm() {
        setConfirmDialogIsOpen(false);
        return navigate(`${ROUTER_PATHS.inventario.trasladoInventarioSolicitudEgresoNav.replace(':id_solicitudegreso', String(idSolicitudEgreso))}`);
        //return navigate(`/inventario/egresos/crear/${idSolicitudEgreso}`);
      },
      onClose() {
        setConfirmDialogIsOpen(false);
      },

    })

  }
  ///
  const columns = useMemo<MRT_ColumnDef<DetalleUsuarios>[]>(
    () => [
      {
        accessorKey: "numero_referencia",
        header: "N° solicitud",
        size: 200,
        width: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "usuario",
        size: 200,
        width: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
        size: 200,
      },
      {
        ...cellNotFilter,
        accessorKey: "ubicacion_data.nombre",
        header: "ubicacion",
        size: 200,
      },

      {
        accessorKey: "observaciones.observacionSolicitudPedido",
        header: "observación",
        size: 200,
        Cell:({ row }) => {
          return <ModalObservacionGeneral
            texto={
              row.original.observaciones?.observacionSolicitudPedido || 'N/A'
            }
            title="Observacion del Solicitante"
          />
        }
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "Fecha de creacion",
        size: 200,
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')

      },

      {
        ...cellNotFilter,
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor="blue"
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ],
    []
  );
  const onChangeMotivoRechazo = (value: string) => {
    form.setValue("motivo_rechazo", value);

  };

  const onDetails = (e: MRT_RowData) => {
    const aux = e.productos.map((item: MaterialTransferido) => ({
      ...item,
      cantidad_aprobada: Number(item.cantidad)
    }))
    handleCopiarLista(aux)
    // handleCopiarLista(e.productos)
    //setDetails(JSON.parse(JSON.stringify(e.productos)));
    setIsModalOpen(true);
    setIdEdit(e.id_solicitudegreso);
    setIdSolicitudEgreso(e.id_solicitudegreso)
    setIsVisibility1(false);

  };
  console.log(onDetails)

  const columnsProductosDetallePedidosDb: MRT_ColumnDef<MaterialTransferido>[] =
    useMemo<MRT_ColumnDef<MaterialTransferido>[]>(
      () => [
        {
          accessorKey: 'cantidad',
          header: 'Cantidad Requerida',
        },
        {
          accessorKey: 'cantidad_aprobada',
          header: 'Cant. A Aprobar',
          Cell: ({ row }) => {
            const cantidadMaxima = Number(row.original.cantidad)
            return (
              <CustomCantidadRecibidaInput
                //value={Number(row.original.cantidad_aprobada) || 0}
                value={Number(row.original.cantidad) || 0}
                maxValue={cantidadMaxima}
                handleValue={(value) => {
                  handleActualizarProducto(row.original.id, {
                    ...row.original,
                    cantidad_aprobada: value
                  }
                  )
                }}
                row={row}
              />
            )
          }

        },

        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'producto_data.descripcion',
          header: 'Descripción',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
        {
          accessorKey: 'producto_data.stock_actual',
          header: 'Stock Actual'
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Medida',
          Cell: ({ row }) => row.original.producto_data?.unidad_medida || "N/A"
        }
      ],
      []
    );

  const {
    pagination,
    setPagination,
    dateBefore,
    dateAfter,
    searchTerm
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;
  const { columnFilters, setColumnFilters, filterObject } = useTableServerSideFiltering();

  const { data: MotivoRechazoPaging, isLoading: isLoadingMotivoRechazo } =
    useFetchMotivosRechazo({
      page_size: 600,
    });
  const {
    data: solicitudPedidosEnesperaRes,
    isLoading: isLoadingSolicitudesPedidoPaging,
    isRefetching,
    refetch,
  } = useFetchSolicitudesEgreso({
    page_size: pageSize,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudPeodidoEnum.ESPERA,
    numero_referencia: searchTerm, /// filtrando por numeroreferencia
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    ...filterObject,
    filterByState: false,

  });
  ////
  ///const {}=useFetchProductos()
  //estado secundario, permite vaciar el campo, solo cuando escucha cambios
  useEffect(() => {
    if (!isModalOpen3) {
      form.setValue('motivo_rechazo', '')
    }
  }, [isModalOpen3, form.setValue])


  //*clear Array
  useEffect(() => {
    return () => {
      clearSelectedItems()
    }
  }, [])



  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
        </Grid>

        <Grid item xs={12}>
          <GeneralTable<SolicitudesEgreso>
            columns={columns}
            data={solicitudPedidosEnesperaRes?.data?.data || []}
            //
            isLoading={isLoadingSolicitudesPedidoPaging}
            isRefetching={isRefetching}
            ///search
            enableGlobalFilter={false}
            //pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={solicitudPedidosEnesperaRes?.data?.count}
            ///actionsColumnSize={120}
            //
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}

            // crud
            enableColumnActions={true}
            ///curd
            canDelete={false}
            positionActionsColumn="first"
            canEdit={false}
            enableEditing={true}

            ///
            //actionsColumnSize={TABLE_CONSTANTS.ACTIONCOLUMN_WIDTH}
            showCustomActionBtnSpace={true}
            customActionBtnSpace={(value) => {
              return (
                <>

                  <Grid container>

                    <Grid item>
                      <Tooltip placement="top" title={'Aprobar/Rechazar'}>
                        <IconButton
                          onClick={() => {

                            //onDetails(value); setIsVisibility1(true) 
                            return navigate(`${ROUTER_PATHS.inventario.solicitud_pedido_revision_nav.replace(':id', String(value.id_solicitudegreso))}`)
                          }}
                        >
                          <NoteAltIcon />
                        </IconButton>

                      </Tooltip>

                    </Grid>
                  </Grid>
                </>

              )
            }}

          />
        </Grid>
        <ScrollableDialogProps
          open={isModalOpen}
          title="Productos"
          confirmTextBtn="Aprobar"
          confirmBtnColor="success"
          confirmVariantBtn="contained"
          minWidth='75%'
          onConfirm={() => { onSaveEdit() }}
          onCloseIcon={() => { setIsModalOpen(false), clearSelectedItems() }}
          showConfirmBtn={true}
          showRejectBtn={true}
          rejectVariantBtn={'outlined'}
          rejectBtnColor="error"
          onReject={() => {
            setIsModalOpen3(true);
          }}

          contentNode={
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <SampleTablePagination
                    columns={columnsProductosDetallePedidosDb}
                    data={paginatedData}
                    rowCount={productos.length}
                    pagination={paginationTableProducto}
                    setPagination={setPaginationTableProducto}
                    rowNumber={true}
                  />
                </Grid>
              </Grid>
              {isVisibility1 !== false && (
                <Grid container xs={12}>
                  <TextField
                    variant="outlined"
                    label='Observación'
                    multiline
                    rows={2}
                    fullWidth
                    {...form.register("observaciones")}
                    error={!!errors.observaciones}
                    helperText={errors.observaciones?.message}
                  />
                </Grid>

              )}
            </>

          }

        />

        <ScrollableDialogProps
          open={isModalOpen3}
          title="Rechazar la solicitud"
          cancelTextBtn="Cancelar"
          //confirmTextBtn="Rechazar"
          showRejectBtn={true}
          rejectBtnColor="error"
          rejectVariantBtn="outlined"
          onReject={handleConfirm}
          contentNode={
            <>
              <CustomAutocomplete<MotivoRechazo>
                label="Motivo"
                name="motivo_rechazo"
                // options
                options={(MotivoRechazoPaging?.data.data as any) || []}
                valueKey="nombre" // name is the fk
                actualValueKey="codigo"
                defaultValue={form.getValues().motivo_rechazo || ""}
                isLoadingData={isLoadingMotivoRechazo}
                control={control}
                error={errors.motivo_rechazo}
                helperText={errors.motivo_rechazo?.message}
                onChangeValue={onChangeMotivoRechazo}
                optionLabelForEdit={
                  MotivoRechazoPaging?.data.data
                    .find((z) => z.codigo === form.getValues().motivo_rechazo)
                    ?.id_motivo_rechazo?.toString() || ""
                }
              />
            </>
          }
          //onConfirm={handleConfirm}
          onClose={() => {
            setIsModalOpen3(false);
          }}
        />
      </Grid>
    </>

  );
}
